import React, { useState, useEffect, useRef }from 'react';
import { useForm } from 'react-hook-form';
import { Modal, Button, Form, InputGroup } from 'react-bootstrap';
import api from '../conexao.js';
import 'react-datepicker/dist/react-datepicker.css';
import { useNavigate, useParams } from 'react-router-dom';
import InputMask from 'react-input-mask';
import '../../App.css';
import logOut from '../logOut';
import SignaturePad from 'react-signature-canvas';
import './CadastroMedico.css';
import novo from '../../img/novo.jpg';
import rodape from '../../img/rodape.jpg';



export default function EditarMedico(){

        const nave = useNavigate();
        const {id} = useParams();
// EditarMedico.propTypes = {
//     id: PropTypes.number.isRequired
// }

const {register, handleSubmit, setValue} = useForm( );  //REGISTRANDO AS FUNÇÕES DO USEFORM
const [exibirModal, setExibirModal] = useState(false); // const para definir se a modal aparece ou nao
const [medNome, setMedNome] = useState();
const [tel, setTEL] = useState();
const [cel, setCEL] = useState();
const [cpf, setCPF] = useState();
const [modalMSG, setModalMSG] = useState(false);
const [MSG, setMSG] = useState();
const [cabecalho, setCabecalho] = useState();
const [rodape, setRodape] = useState();
const [tipoReceituario, setTipoReceituario] = useState('proprio');
const [alturaCabecalho, setAlturaCabecalho] = useState(30);
const [alturaRodape, setAlturaRodape] = useState(30);
const [modalPreview, setModalPreview] = useState(false);
const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
const assinatura = useRef({})
const [cabFile, setcabFile] = useState();
const [rodFile, setrodFile] = useState();
const [assinaturaVazia, setAssinaturaVazia] = useState(true);
var sign;

var telnum = String;
var celnum = String;
var cpfnum = String;

useEffect( () => {
    api.get('/medico/',{  params: {           
        codigo: id,}}).then(result => {
           setValue("NOME", result.data.NOME);
           setValue("ENDERECO", result.data.ENDERECO);
           setValue("BAIRRO", result.data.BAIRRO);
           setValue("CIDADE", result.data.CIDADE);
           setValue("CRM", result.data.CRM);
           setCabecalho(result.data.CABECALHO);
           setRodape(result.data.RODAPE);
           
           // Detectar tipo de receituário baseado nos dados
           if (result.data.CABECALHO && result.data.CABECALHO.includes('mm')) {
               setTipoReceituario('timbrado');
               setAlturaCabecalho(parseInt(result.data.CABECALHO.replace('mm', '')));
           }
           if (result.data.RODAPE && result.data.RODAPE.includes('mm')) {
               setAlturaRodape(parseInt(result.data.RODAPE.replace('mm', '')));
           }
           if (result.data.ASSINATURA) {
                        sign = Buffer.from(result.data.ASSINATURA).toString();
                        // Limpar antes de carregar para evitar sobreposição
                        assinatura.current.clear();
                        // Carregar com o tamanho correto
                        assinatura.current.fromDataURL(sign, {
                            width: 320,
                            height: 200,
                            xOffset: 0,
                            yOffset: 0
                        });
                        setAssinaturaVazia(false);
                } else {
                    assinatura.current.clear();
                    setAssinaturaVazia(true);
                }
           if (result.data.TEL) {  
             setTEL(result.data.TEL.toString());
             setValue("TEL", tel);
           }
           if (result.data.CEL) { 
             setCEL(result.data.CEL.toString());
             setValue("CEL", cel);
           }
           if (result.data.CPF) { 
             setCPF(result.data.CPF.toString());
             setValue("CPF", cpf);     
           }     
              

    }) .catch(        
                (error) => {
                setMSG(logOut(error))
                setModalMSG(true)
    })   
    
}, [id]);



function gravaAssinatura() {
        if (assinatura.current.isEmpty()) {
            sign = null; // Salvar como null quando assinatura está vazia
        } else {
            sign = assinatura.current.toDataURL(); // GRAVAR A VARIAVEL SIGN NO BANCO E RESTAURAR PARA APARECER A ASSINATURA
        }
}

function handleFecharModal(){
        setExibirModal(false); // inicia faalse
        nave('/medico/medico'); // vai para pagina anterior
}
function handleVoltar(){
        nave('/medico/medico');
}

 const onSubmit = (data) => {

        if  (tel)  {
                telnum = tel;
                telnum = telnum.replace(/[^0-9]+/g, "");
        }
        if (cel) {
                celnum = cel;
                celnum = celnum.replace(/[^0-9]+/g, "");
        }
        if (cpf) {
                cpfnum = cpf;
                cpfnum = cpfnum.replace(/[^0-9]+/g, "");
        }
        if (tipoReceituario === 'proprio') {
            if (cabecalho) { data.CABECALHO = 'cab ' + data.NOME.substring(0,10).toLowerCase() + '.jpg'} else {data.CABECALHO = ''}
            if (rodape)    { data.RODAPE    = 'rod ' + data.NOME.substring(0,10).toLowerCase() + '.jpg'} else {data.RODAPE = ''}
        } else {
            data.CABECALHO = alturaCabecalho + 'mm';
            data.RODAPE = alturaRodape + 'mm';
        }
        // console.log(data.cabecalho)
        //GRAVA ASSINATURA EM VAR sign
        gravaAssinatura()

        async function Grava() {
                
              await  api.put('/medico/'+ id, {
                        NOME:  data.NOME.toUpperCase(),
                        ENDERECO: data.ENDERECO.toUpperCase(),
                        BAIRRO: data.BAIRRO.toUpperCase(),
                        CIDADE: data.CIDADE.toUpperCase(),
                        CRM: data.CRM.toUpperCase(),
                        TEL: telnum,
                        CEL: celnum,
                        CPF: cpfnum,
                        CABECALHO: data.CABECALHO,
                        RODAPE: data.RODAPE,
                        ASSINATURA: sign
                }).then(
                        () => {
                        setMedNome(data.NOME);
                        setExibirModal(true);
                        }
                ).catch(        
                        (error) => {
                        setMSG(logOut(error))
                        setModalMSG(true)
                })   
        }    

 
        const formDataCabecalho = new FormData();
        const formDataRodape = new FormData();

        formDataCabecalho.append('file',cabFile);
        formDataCabecalho.append('nomeFile', 'cab ' + data.NOME.substring(0,10).toLowerCase() + '.jpg')

        formDataRodape.append('file',rodFile);
        formDataRodape.append('nomeFile','rod ' + data.NOME.substring(0,10).toLowerCase() + '.jpg');

        const uploadCabecalho = async () => {
                await api.post('/logo', formDataCabecalho)
        };

        const uploadRodape = async () => {
                await api.post('/logo', formDataRodape)
        };

      
        Grava();
        if (tipoReceituario === 'proprio') {
            if (cabFile !== undefined) {uploadCabecalho()} 
            if (rodFile !== undefined) {uploadRodape()}
        } 

    }


    function funcCabecalho(e) {
        const cabeca = e.target.files[0];
          setCabecalho(cabeca.name);
        setcabFile(cabeca);
    }

    function funcRodape(e) {
        const roda = e.target.files[0];
          setRodape(roda.name);
        setrodFile(roda);
    }
    
    async function previewPDF() {
        
        // Verificar se assinatura está vazia
        const hasValidSignature = !assinaturaVazia;
        
        // Verificar se receituário próprio tem imagens anexadas
        if (tipoReceituario === 'proprio') {
            const temCabecalhoExistente = cabecalho && !cabecalho.includes('mm');
            const temRodapeExistente = rodape && !rodape.includes('mm');
            if (!cabFile && !rodFile && !temCabecalhoExistente && !temRodapeExistente) {
                setMSG('Anexe pelo menos uma imagem (cabeçalho ou rodapé) para o receituário próprio.');
                setModalMSG(true);
                return;
            }
        }
        
        const pdfMake = require('pdfmake/build/pdfmake');
        const pdfFonts = require('pdfmake/build/vfs_fonts');
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        
        gravaAssinatura();
        
        // Função para converter mm para pontos
        const mmToPoints = (mm) => Math.round(mm * 4.4);
        
        let cabecalhoHeight = 78;
        let rodapeHeight = 60;
        
        if (tipoReceituario === 'timbrado') {
            cabecalhoHeight = mmToPoints(alturaCabecalho);
            rodapeHeight = mmToPoints(alturaRodape);
        }
        
        // Verificar se há imagens carregadas (novas ou existentes)
        const temCabecalhoExistente = cabecalho && !cabecalho.includes('mm');
        const temRodapeExistente = rodape && !rodape.includes('mm');
        const temImagemCabecalho = (cabFile || temCabecalhoExistente) && tipoReceituario === 'proprio';
        const temImagemRodape = (rodFile || temRodapeExistente) && tipoReceituario === 'proprio';
        
        // Converter arquivos para base64
        const fileToBase64 = (file) => {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.readAsDataURL(file);
            });
        };
        
        // Buscar nome do médico para construir URL das imagens
        let nomeMedico = '';
        try {
            const medicoResult = await api.get('/medico/', { params: { codigo: id } });
            nomeMedico = medicoResult.data.NOME || '';
        } catch (error) {
            console.error('Erro ao buscar nome do médico:', error);
        }
        
        let cabecalhoBase64, rodapeBase64;
        if (temImagemCabecalho) {
            if (cabFile) {
                cabecalhoBase64 = await fileToBase64(cabFile);
            } else if (temCabecalhoExistente) {
                // Usar imagem existente do servidor
                cabecalhoBase64 = 'https://imgsti.s3.sa-east-1.amazonaws.com/cab+' + 
                    nomeMedico.substring(0,10).replace(' ','+').toLowerCase() + '.jpg?' + new Date().getTime();
            }
        }
        if (temImagemRodape) {
            if (rodFile) {
                rodapeBase64 = await fileToBase64(rodFile);
            } else if (temRodapeExistente) {
                // Usar imagem existente do servidor
                rodapeBase64 = 'https://imgsti.s3.sa-east-1.amazonaws.com/rod+' + 
                    nomeMedico.substring(0,10).replace(' ','+').toLowerCase() + '.jpg?' + new Date().getTime();
            }
        }
        
        // Criar docDefinition com bordas vermelhas apenas para receituário timbrado
        const docDefinitions = {
            pageSize: 'A4',
            pageMargins: [15, Math.max(50, cabecalhoHeight + 20), 15, Math.max(50, rodapeHeight + 20)],
            header: temImagemCabecalho ? 
                { image: 'cabecalhoImg', width: 530, height: cabecalhoHeight, alignment: 'center', margin: [0, 10] } :
                {
                    canvas: [
                        {
                            type: 'rect',
                            x: 0,
                            y: 10,
                            w: 595,
                            h: cabecalhoHeight,
                            lineColor: 'red',
                            lineWidth: 2,
                            dash: { length: 5 }
                        },
                        {
                            type: 'text',
                            x: 297,
                            y: cabecalhoHeight / 2 + 15,
                            text: 'ÁREA DO CABEÇALHO',
                            fontSize: 12,
                            color: 'red',
                            alignment: 'center'
                        }
                    ]
                },
            content: [
                { text: 'Receituário', fontSize: 17.5, bold: true, alignment: 'center', margin: [0, 5, 0, 0] },
                {
                    columns: [
                        { text: 'Paciente: PACIENTE EXEMPLO', fontSize: 12, width: '*' },
                        { text: `Data: ${new Date().toLocaleDateString()}`, fontSize: 12, width: 'auto', alignment: 'right' }
                    ],
                    margin: [0, 10]
                },
                { text: 'Texto de exemplo para visualização do layout do receituário.', margin: [0, 20] },
                ...(hasValidSignature ? [{
                    canvas: [{
                        type: 'rect',
                        x: 200, y: 0, w: 130, h: 75,
                        lineColor: '#ccc', lineWidth: 1
                    }],
                    margin: [0, 20, 0, 0]
                }, { text: 'Assinatura do Médico', fontSize: 8, alignment: 'center', margin: [0, -10, 0, 0] }] : []),
                { text: 'NOME DO MÉDICO', fontSize: 12, bold: true, alignment: 'center', margin: [0, 30, 0, 0] },
                { text: 'CRM 12345', fontSize: 10, bold: true, alignment: 'center', margin: [0, 7, 0, 0] }
            ],
            footer: function() {
                return temImagemRodape ? 
                    { image: 'rodapeImg', width: 530, height: rodapeHeight, alignment: 'center', margin: [0, 0, 0, 10] } :
                    {
                        canvas: [
                            {
                                type: 'rect',
                                x: 0,
                                y: 0,
                                w: 595,
                                h: rodapeHeight,
                                lineColor: 'red',
                                lineWidth: 2,
                                dash: { length: 5 }
                            },
                            {
                                type: 'text',
                                x: 297,
                                y: rodapeHeight / 2,
                                text: 'ÁREA DO RODAPÉ',
                                fontSize: 12,
                                color: 'red',
                                alignment: 'center'
                            }
                        ]
                    };
            },
            images: {
                ...(temImagemCabecalho && { cabecalhoImg: cabecalhoBase64 }),
                ...(temImagemRodape && { rodapeImg: rodapeBase64 })
            },
            defaultStyle: {
                fontSize: 10,
                color: 'black'
            }
        };
        
        const pdfDocGenerator = pdfMake.createPdf(docDefinitions);
        pdfDocGenerator.getBlob((blob) => {
            const url = URL.createObjectURL(blob);
            setPdfPreviewUrl(url);
            setModalPreview(true);
        });
    } 

        return (

                <div>
        

                <div className="cadastroMedico-formContainer">
                      <h2 className="cadastroMedico-title">Editar Médico</h2>
                      <form onSubmit={handleSubmit(onSubmit)} className='cadastroMedico-form '>
                        <div className="cadastroMedico-formGroup">
                          <label className="cadastroMedico-label">Nome:</label>
                          <input className="cadastroMedico-input" type="text" name="NOME" maxLength={45}
                          style={{textTransform:"uppercase"}} 
                          required
                          {...register('NOME',{minLength: 10})}  />
                        </div>
                        <div className="cadastroMedico-formGroup3">
                        <label className="cadastroMedico-label">CRM:</label>
                         <Form.Control style={{textTransform:"uppercase"}} 
                            type="text" 
                            size="sm" 
                            maxLength={15}
                            name="CRM" 
                            {...register('CRM')} 
                            required
                            />
                        </div>
                        <div className="cadastroMedico-formGroup">
                          <label className="cadastroMedico-label">Endereço:</label>
                          <input className="cadastroMedico-input" type="text" name="ENDERECO" maxLength={45}
                           {...register('ENDERECO')}
                           style={{textTransform:"uppercase"}}  />
                        </div>
                        <div className="cadastroMedico-formGroup">
                          <label className="cadastroMedico-label">Bairro:</label>
                          <input className="cadastroMedico-input" type="text" name="BAIRRO" maxLength={45}
                          style={{textTransform:"uppercase"}} 
                          {...register('BAIRRO')}/>
                        </div>
                        <div className="cadastroMedico-formGroup">
                          <label className="cadastroMedico-label">Cidade:</label>
                          <input className="cadastroMedico-input" type="text" name="CIDADE" maxLength={45}
                          style={{textTransform:"uppercase"}}
                          {...register('CIDADE')}/>
                        </div>
                        <div className="cadastroMedico-formGroup3">
                          <label className="cadastroMedico-label">Tel.:</label>
                          {/* <input className="cadastroMedico-input" type="text" name="telefone" {...register('TEL')} /> */}
                                 <InputMask
                                         mask="(99)9999-9999"
                                         size="24"
                                         name="TEL"
                                         {...register('TEL')}
                                         value={tel}
                                         onChange={(e) => setTEL(e.target.value)}
                                         alwaysShowMask={false}
                                 /> 
                        </div>
                        <div className="cadastroMedico-formGroup3">
                          <label className="cadastroMedico-label">Cel.:</label>
                          {/* <input className="cadastroMedico-input" type="text" name="celular" {...register('CEL')} /> */}
                          <InputMask
                                        mask="(99)99999-9999"
                                        size="24"
                                        name="CEL"
                                        {...register('CEL')}
                                        value={cel}
                                        onChange={(e) => setCEL(e.target.value)}
                                        alwaysShowMask={false}
                                />
                        </div>
                        <div className="cadastroMedico-formGroup3">
                          <label className="cadastroMedico-label">CPF:</label>
                          {/* <input className="cadastroMedico-input" type="text" name="cpf" {...register('CPF')}/> */}
                          <InputMask
                                        mask="999.999.999-99"
                                        size="24"
                                        name="CPF"
                                        {...register('CPF')}
                                        value={cpf}
                                        onChange={(e) => setCPF(e.target.value)}
                                        alwaysShowMask={false}
                                />
                        </div>
                        <div className="cadastroMedico-formGroup">
                            <label className="cadastroMedico-label">Tipo de Receituário:</label>
                            <div>
                                <Form.Check 
                                    type="radio"
                                    label="Receituário Próprio (com imagens)"
                                    name="tipoReceituario"
                                    checked={tipoReceituario === 'proprio'}
                                    onChange={() => setTipoReceituario('proprio')}
                                />
                                <Form.Check 
                                    type="radio"
                                    label="Receituário Timbrado (espaçamento)"
                                    name="tipoReceituario"
                                    checked={tipoReceituario === 'timbrado'}
                                    onChange={() => setTipoReceituario('timbrado')}
                                />
                            </div>
                        </div>
                        
                        {tipoReceituario === 'proprio' && (
                            <>
                                <div className="cadastroMedico-formGroup3">
                                    <label className="cadastroMedico-label">Cabeçalho</label>
                                    {cabecalho && !cabecalho.includes('mm') && <label style={{color: "red"}} > Já existe Cabeçalho associado!</label>}
                                    <Form.Control  type="file" name="cabecalho" accept="image/jpeg" style={{width:"143px"}} onChange={e => funcCabecalho(e)} />
                                    {cabecalho && !cabecalho.includes('mm') && <Button className="btn btn-danger" onClick={() => {setCabecalho()}}>Remover</Button>}
                                </div>

                                <div className="cadastroMedico-formGroup3">
                                    <label className="cadastroMedico-label">Roda-pé</label>
                                    {rodape && !rodape.includes('mm') && <label style={{color: "red"}} > Já existe Roda-pé associado!</label>}
                                    <Form.Control type="file" name="rodape" accept="image/jpeg" style={{width:"143px"}}  onChange={e => funcRodape(e)}/>
                                    {rodape && !rodape.includes('mm') && <Button className="btn btn-danger" onClick={() => {setRodape()}}>Remover</Button>}
                                </div>
                            </>
                        )}
                        
                        {tipoReceituario === 'timbrado' && (
                            <>
                                <div className="cadastroMedico-formGroup3">
                                    <label className="cadastroMedico-label">Altura do Cabeçalho</label>
                                    <InputGroup>
                                        <InputGroup.Text>mm</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            placeholder="mm"
                                            min="30"
                                            max="70"
                                            value={alturaCabecalho}
                                            onChange={e => setAlturaCabecalho(e.target.value)}
                                        />
                                    </InputGroup>
                                </div>
                                <div className="cadastroMedico-formGroup3">
                                    <label className="cadastroMedico-label">Altura do Rodapé</label>
                                    <InputGroup>
                                        <InputGroup.Text>mm</InputGroup.Text>
                                        <Form.Control
                                            type="number"
                                            placeholder="mm"
                                            min="10"
                                            max="70"
                                            value={alturaRodape}
                                            onChange={e => setAlturaRodape(e.target.value)}
                                        />
                                    </InputGroup>
                                </div>
                            </>
                        )}
                         
                        <div className="cadastroMedico-formGroup">
                           <label className="cadastroMedico-label">Assinatura</label>
                                <div>        
                                        <div style={{borderStyle: "solid", borderWidth: "1px", width:"320px", position: 'relative'}}>
                                                <SignaturePad  
                                                    ref={assinatura} 
                                                    canvasProps={{width: 320, height: 200}}
                                                    onBegin={() => setAssinaturaVazia(false)}
                                                />    
                                                {assinaturaVazia && (
                                                    <div style={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        left: '50%',
                                                        transform: 'translate(-50%, -50%)',
                                                        color: '#ccc',
                                                        fontSize: '14px',
                                                        pointerEvents: 'none'
                                                    }}>
                                                        Sem assinatura
                                                    </div>
                                                )}
                                        </div>
                                        <Button className="btn btn-warning"  onClick={()=> {assinatura.current.clear(); setAssinaturaVazia(true);}}>Limpar</Button>  
                                </div>
                        </div>
            

                        <div className="cadastroPaciente-formActions">
                          <Button className="btn-primary"  type="submit">Gravar</Button>
                          <Button className="btn-info" onClick={previewPDF}>Visualizar PDF</Button>
                          <Button className="btn-secondary" 
                          onClick={() => {handleVoltar()}}  type="submit">Cancelar</Button>
                        </div> 
                     </form>
                </div>
            


        <Modal show={exibirModal} onHide={handleFecharModal} backdrop="static">
                <Modal.Header>
                        <h2> Alteração feita com Sucesso! </h2>
                </Modal.Header>
                <Modal.Body>
                  Médico: <strong>{medNome}</strong>, Alterado!                  
                </Modal.Body>
                <Modal.Footer>
                        <Button variante="success" onClick={() => handleFecharModal()}> Ok </Button>
                </Modal.Footer>
                
        </Modal>
        <Modal show={modalMSG}>
                <Modal.Header> 
                    <h3>{MSG}</h3>
                </Modal.Header> 
                <Modal.Footer>
                    <Button variant="info" onClick={() => setModalMSG(false)}>Ok</Button>
                </Modal.Footer>
            </Modal> 
            
        <Modal show={modalPreview} size="lg" centered onHide={() => {URL.revokeObjectURL(pdfPreviewUrl); setPdfPreviewUrl(null); setModalPreview(false);}}>
            <Modal.Header closeButton> 
                <h3>Visualização do Layout</h3>
            </Modal.Header> 
            <Modal.Body>
                {pdfPreviewUrl && <iframe src={pdfPreviewUrl + '#toolbar=0'} style={{width: '100%', height: '600px', border: 'none'}} title="Preview PDF"></iframe>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={() => {URL.revokeObjectURL(pdfPreviewUrl); setPdfPreviewUrl(null); setModalPreview(false);}}>Fechar</Button>
            </Modal.Footer>
        </Modal>
        </div>
 

                )

}



